export default "__VITE_ASSET__DeBejwQG__"